import React, { useContext, useEffect, useRef, useState } from "react";
import { isUserExistForUpdation } from "../../../oscar-pos-core/constants";
import {
  findCustomerByID,
  getCustomersByBusiness,
} from "../../../database/helpers/customer";
import { UBInput, UBRadioBox } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";

import { Sync } from "../../../SyncService";
import { phoneNumRegex } from "../../../validations";
import { SEVERITY, uuid } from "../../../constants";
import { toast } from "react-toastify";
import { useSnackbar } from "../../../context/SnackbarContext";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { Box } from "@material-ui/core";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const EditCustomer = ({
  customer,
  closeCallback,
  handleRemindToast = null,
  isAddFlow = false,
  initialName = "",
  initialPhone = "",
  onSaveCallback = () => {},
  type = "in",
  title = "",
  isTypeField = true,
  handleLogEventCustomerCreated = () => {},
  handleLogEventCustomerUpdate = () => {},
  isOnlyPhoneList,
  formId = "edit_customer_form",
  onFormStateChange = () => {},
  onRemoteSave = null,
  remoteCustomerId = null,
}) => {
  const { showSnackbar } = useSnackbar();
  const customerTypes = ["Customer", "Supplier"];
  const nameInputRef = useRef();
  const phoneInputRef = useRef();
  const customerName = customer?.name || initialName;
  const customerPhone = customer?.phone_number || initialPhone;
  const [custName, setCustName] = useState(customerName);
  const [custPhone, setCustPhone] = useState(customerPhone);
  const [custType, setCustType] = useState(
    customer?.is_supplier || type === "out"
      ? customerTypes[1]
      : customerTypes[0],
  );
  const [phoneErr, setPhoneError] = useState({
    text: "Please Enter valid phone number",
    show: false,
  });
  const [nameErr, setNameError] = useState({
    text: "",
    show: false,
  });
  const [loading, setLoading] = useState(false);

  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();
  const isSaveDisabled =
    loading ||
    !custName.trim() ||
    (isOnlyPhoneList ? (custPhone?.length || 0) < 11 : false);

  useEffect(() => {
    if (nameInputRef.current) {
      customerName
        ? phoneInputRef.current.focus()
        : nameInputRef.current.focus();
    }
  }, [customerName]);

  useEffect(() => {
    onFormStateChange({
      loading,
      disabled: isSaveDisabled,
    });
  }, [loading, isSaveDisabled, onFormStateChange]);
  const validateName = () => {
    if (!custName?.length) {
      setNameError({
        text: I18n.name_can_not_be_empty,
        show: true,
      });
      return false;
    }
    return true;
  };
  const validatePhone = async () => {
    if (custPhone?.length) {
      let patt = phoneNumRegex;
      if (!(custPhone?.length === 11)) {
        setPhoneError({
          text: I18n.phone_number_length,
          show: true,
        });
        return false;
      } else if (custPhone?.match?.(patt) === null) {
        setPhoneError({
          text: "Mobile number should be in format e.g. 03001234567",
          show: true,
        });
        return false;
      }
      const customers = await getCustomersByBusiness(
        localStorage.getItem("business_id"),
      );
      let isExist = isUserExistForUpdation(
        customers,
        custPhone,
        customer?.id || null,
      );
      if (isExist) {
        setPhoneError({
          text: isExist?.is_supplier
            ? I18n.this_number_associate_with_another_supplier
            : I18n.this_number_associate_with_another_customer,
          show: true,
        });
        return false;
      } else return true;
    } else {
      setPhoneError("");
      return false;
    }
  };
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (onRemoteSave) {
      if (!validateName()) {
        setLoading(false);
        return;
      }
      try {
        await onRemoteSave({
          customer_id: remoteCustomerId,
          customer_name: custName,
        });
        showSnackbar({ message: I18n.customer_updated_successfully, severity: "success" });
        onSaveCallback?.();
        closeCallback();
      } catch (error) {
        showSnackbar({
          message: error?.response?.data?.message || "Sorry, cannot process the request at the moment",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
      return;
    }

    let data = {
      name: custName,
      phone: custPhone,
      is_supplier: custType === customerTypes[1],
      transaction_sms: false,
    };
    const isPhoneMissing = isOnlyPhoneList && !custPhone?.trim();
    if (!validateName() || isPhoneMissing) {
      if (isPhoneMissing) {
        setPhoneError({ show: true, text: "Please provide a phone number" });
      }
      setLoading(false);
      return;
    } else if (custPhone?.length && !(await validatePhone())) {
      setLoading(false);
      return;
    } else {
      if (isAddFlow) {
        let newCustomerData = {
          id: uuid(),
          total_outstanding_payment: 0,
          ...data,
        };
        if (business) {
          try {
            await business.createCustomer(newCustomerData);
            triggerLogEvent(analytics, "acc_customer_created", { type: custType });
            handleLogEventCustomerCreated();

            const res = await findCustomerByID(newCustomerData.id);
            Sync(user?.phone_number, navigate);
            onSaveCallback && onSaveCallback(res);
            showSnackbar({
              message: `${
                custType === customerTypes[0]  ? I18n.customer_created : I18n.supplier_created
              }`,
              severity: "success",
            });
            setLoading(false);
          } catch (error) {
            setLoading(false);
            toast.error("Sorry, cannot process the request at the moment", {
              className: "errorToast",
            });
          }
        }
      } else {
        if (!custPhone?.length) {
          setPhoneError({
            show: true,
            text: "Please provide a phone number",
          });
          setLoading(false);
          return;
        }
        const res = localStorage.getItem("smsConfig");
        if (res) {
          let arr = res.split(",");
          if (arr.includes(customer.id)) {
            let smsConfig = arr.filter((x) => x != customer.id);

            const sms = localStorage.setItem("smsConfig", smsConfig.toString());
          }
        }
        data.transaction_sms = true;

        customer
          .updateCustomer(data)
          .then(() => {
            triggerLogEvent(analytics, "acc_customer_updated", { type: custType });
            handleLogEventCustomerUpdate();
            Sync(user?.phone_number, navigate);
            const successMsg = customer.is_supplier
              ? I18n.supplier_updated_successfully
              : I18n.customer_updated_successfully;
            if (handleRemindToast) {
              handleRemindToast(successMsg, SEVERITY.SUCCESS);
            } else {
              showSnackbar({ message: successMsg, severity: "success" });
            }
            onSaveCallback?.(customer);
            closeCallback();
            setLoading(false);
          })
          .catch(() => {
            const errMsg = "Sorry, cannot process the request at the moment";
            if (handleRemindToast) {
              handleRemindToast(errMsg, SEVERITY.ERROR);
            } else {
              showSnackbar({ message: errMsg, severity: "error" });
            }
            closeCallback();
            setLoading(false);
          });
      }
    }
  };
  return (
    <form className={styles.form} onSubmit={handleSave} id={formId}>
      {isTypeField && (
        <Box className={styles.typeRow}>
          <UBRadioBox
            label={I18n.customer}
            onChange={(value) => {
              setCustType(value);
            }}
            value={custType}
          />
          <UBRadioBox
            label={I18n.supplier}
            onChange={(value) => {
              setCustType(value);
            }}
            value={custType}
          />
        </Box>
      )}
      <UBInput
        inputId="edit_customer_name"
        label={
           custType === customerTypes[0] ? I18n.customer_name : I18n.supplier_name
        }
        placeholder={custType === customerTypes[0] ? I18n.enter_customer_name : I18n.enter_supplier_name}
        required
        value={custName}
        onChange={(key, value) => {
          setNameError("");
          setCustName(value);
        }}
        error={nameErr}
        className={nameErr.show ? styles.inputError : ""}
        inputClassname="borderRadius6"
        maxLength={36}
        inputRef={nameInputRef}
      />
      <UBInput
        inputId="edit_customer_phone"
        label={I18n.phone_number}
        value={custPhone}
        onChange={(key, value) => {
          setPhoneError("");
          if (!value) {
            setCustPhone("");
          } else {
            setCustPhone(value.slice(0, 11));
          }
        }}
        maxLength={11}
        error={phoneErr}
        className={phoneErr.show ? styles.inputError : ""}
        inputClassname="borderRadius6"
        onlyNumbers={true}
        isLeadingZero={false}
        placeholder={I18n.enter_phone_number}
        inputRef={phoneInputRef}
        required={isOnlyPhoneList}
      />
    </form>
  );
};
export default EditCustomer;
